

export const ContactPresentation = () => {
  return (
    <>
        <p>Para una atención más personalizada siempre puedes ponerte en contacto con nosotros por este medio.</p>
        <hr />
        <form>
            <div className="mb-3">
                <label htmlFor="inputEmail1" className="form-label">Correo Electrónico</label>
                <input type="email" className="form-control" id="inputEmail1" aria-describedby="emailHelp" />
                <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                <label htmlFor="inputConsult">Ingrese su consulta</label>
                <textarea name="consulta" id="inputConsult" cols={38} rows={5} className="form-control"></textarea>
            </div>
            <div className="mb-3 form-check">
                <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                <label className="form-check-label" htmlFor="exampleCheck1">Check me out</label>
            </div>
            <button type="submit" className="btn btn-primary">Contactar</button>
        </form>
    </>
  )
}
